import { Vehicle, VehicleVersion } from "../types";

type LinkableVersion = Pick<VehicleVersion, "test_drive_url">;

type TestDriveScope = {
  vehicle: Pick<Vehicle, "test_drive_url">;
  // Finition choisie dans le select, si une l'est.
  currentVersion?: LinkableVersion;
  // Finitions de l'APPELLATION affichee, et rien d'autre. Vide sur la fiche de
  // gamme : voir le palier intermediaire ci-dessous.
  modelVersions?: readonly LinkableVersion[];
};

// Resout le lien "Demander un essai" affiche par la fiche vehicule.
//
// La fiche sert trois perimetres -- la gamme, une appellation, une finition --
// mais test_drive_url n'est saisi en admin que sur DEUX niveaux : la gamme et
// la finition. La cascade comble ce trou en remontant du plus specifique au
// plus general :
//
//   finition selectionnee > une finition de l'appellation > gamme > rien
//
// Le palier intermediaire est ce qui rend la page d'une appellation utile : un
// constructeur publie une URL d'essai par appellation (…/vehicules/e-c3.html),
// saisie faute de mieux sur une finition. Sans ce palier, le lien restait
// invisible tant qu'aucune finition n'etait choisie dans le select.
//
// Il est volontairement borne a l'appellation. Sur la fiche de gamme,
// modelVersions est vide : laisser remonter n'importe quelle finition y ferait
// afficher le lien de la e-C3 electrique sur toute la gamme C3, thermiques
// comprises. Une gamme n'emprunte donc jamais le lien de ses finitions -- elle
// n'affiche que le sien.
export function resolveTestDriveUrl({
  vehicle,
  currentVersion,
  modelVersions = [],
}: TestDriveScope): string | null {
  return (
    currentVersion?.test_drive_url ||
    modelVersions.find((version) => version.test_drive_url)?.test_drive_url ||
    vehicle.test_drive_url ||
    null
  );
}
